import styled from 'styled-components';
import { body1, body2, body3 } from '../../tokens';
import { applyHyphens, applySpacing } from '../../mixins';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Typography/Body');
export var Body1 = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-1ysxn8o-0"
})(["", " ", " ", ""], applyHyphens, applySpacing, body1);
export var Body2 = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-1ysxn8o-1"
})(["", " ", " ", ""], applyHyphens, applySpacing, body2);
export var Body3 = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-1ysxn8o-2"
})(["", " ", " ", ""], applyHyphens, applySpacing, body3);